import { forwardRef, type LegacyRef } from 'react';

import { GridComponent, useDashboardHost } from '@highimpact/dashboard';
import ErrorBoundary from '../pages/security/ErrorBoundary';
import SiteDecorator from '../pages/sites/utils/SiteDecorator';

function SiteDashboardPage(_props: object, ref: LegacyRef<HTMLDivElement>) {
  const {
    project_id,
    site_id,
    grid_id,
    mode,
    dashboard_only_mode,
    simplified_view,
  } = useDashboardHost();

  if (mode === 'standalone') {
    return SiteDecorator(
      ref,
      () => (
        <ErrorBoundary>
          <GridComponent
            draggableHandle=".react-grid-dragHandleExample"
            grid_type="grids"
            grid_id={grid_id!}
            is_editable={true}
            dashboard_only_mode={dashboard_only_mode}
            simplified_view={true}
            itemNameCreateBtn="dashboard_create_button"
            itemNameDeleteBtn="dashboard_delete_button"
            itemNameEditEl="dashboard_edit_field"
            itemNameAddWidget="dashboard_add_widgets_button"
          />
        </ErrorBoundary>
      ),
      { mode: 'dashbordonly', grid_id: grid_id ?? undefined }
    );
  }

  const siteContext = simplified_view
    ? {
        mode: 'fullcontext' as const,
        project_id: project_id!,
        site_id: site_id!,
        grid_id: grid_id!,
      }
    : { mode: 'nocontext' as const };

  return SiteDecorator(
    ref,
    (project, site) => (
      <ErrorBoundary>
        <GridComponent
          site={site}
          project={project}
          draggableHandle=".react-grid-dragHandleExample"
          grid_type="grids"
          grid_id={grid_id!}
          is_editable={true}
          dashboard_only_mode={dashboard_only_mode}
          simplified_view={simplified_view}
          itemNameCreateBtn="dashboard_create_button"
          itemNameDeleteBtn="dashboard_delete_button"
          itemNameEditEl="dashboard_edit_field"
          itemNameAddWidget="dashboard_add_widgets_button"
        />
      </ErrorBoundary>
    ),
    siteContext
  );
}

export default forwardRef(SiteDashboardPage);
